<template>
	<div class="customerWallet">
			<b-container fluid class="p-0 mt-2">
				<b-card >
				<b-row class="mb-3 mt-3">
					
					<b-col lg="6" md="12" sm="12">
						<h6><div class="walletIcon"><b-icon class="ml-1 walletFont" icon="wallet2" aria-hidden="true"></b-icon></div><div class="welletText"><span class="heading">Alluraa Wallet</span><br/><small>Your purse to shop on Alluraa</small></div></h6>
						
						<!-- <p>Hello {{$root.customer_info.custname}} (not {{$root.customer_info.custname}}? <b-link href="/customer/logout">Log out</b-link> )</p>
						<p>Fromt your account dashboard you can view your recent orders, manage your shipping and billing addresses and edit your password and account details.</p> -->
					</b-col>
					<b-col lg="6" md="12" sm="12">
						<ul class="p-0">
						<li>Wallet Balance</li>
						<li class="amountTextColor">{{$root.currency()+$root.tofixed(blance, 2)}}</li>
					</ul>
					</b-col>
				</b-row>
				
				<h6 class="ml-4">Transaction History</h6>
				<b-row class="mt-2 walletHistory">
					
					<b-col>
					<ul>
						<li v-if="transaction.length>0">
						<b-row class="walletAc"  v-for="transactionRor in transaction" :key="transactionRor.id">
							<b-col cols="12" lg="2" md="12" sm="12">
								<ul class="p-0">
									<li>Trxn.ID</li>
									<li>#{{transactionRor.id}}</li>
									<li><small>{{$moment(transactionRor.cr_date).format('DD-MM-YYYY')}}</small></li>
								</ul>
							</b-col>
							<b-col cols="8"  lg="8" md="8" sm="8">{{transactionRor.cr_descriptions}}</b-col>
							<b-col cols="4" lg="2" md="4" sm="4"> 
							<span v-if="loginUserId==transactionRor.cr_user_id">
							+{{$root.currency()+ $root.tofixed(transactionRor.cr_amount, 2)}} 
							</span>
							<span v-else>
							-{{$root.currency()+ $root.tofixed(transactionRor.dr_amount, 2)}} 
							</span>
							</b-col>
							
							</b-row>
							</li>
							<li v-else>
									No transaction found!
							</li>
						
					</ul>
						
					</b-col>
				</b-row>
				</b-card>
			</b-container>

	</div>
</template>
<script>

export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
       
	},
	mounted(){
        this.initload();
		if(this.$root.customer_info.role==1){
		this.loginUserId=1;
		}else{
		this.loginUserId=this.$root.customer_info.user_id;
		}
	},
	data() {
		return{
			statusSidebar: false,
            modal_data: {
                price: 0,
                special_price: 0
			},
			slide:0,
			related_products: [],
			loginUserId:0,
			walletRecord: [],
			transaction: [],
			blance: 0,
			cr_amount: 0,
			dr_amount: 0,
			//url: this.$root.WEBURL+'customer-orders',
			recordUrl: this.$root.WEBAPI+'walletapi/mywalletTransaction-record',
		};
	},
	methods: {
		burgerMenuSidebar() {
		  this.statusSidebar = !this.statusSidebar;
		},
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.recordUrl, {
                accesskey: self.$session.get('access_key'),
                roleId: self.$root.customer_info.role,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.walletRecord = response.data.result;
					self.blance		=	response.data.result.blance;
					self.cr_amount	=	response.data.result.cr_amount;
					self.dr_amount	=	response.data.result.dr_amount;
					self.transaction	=	response.data.result.transaction;
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		}
	}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
.col-form-label-sm{
padding:0px;
margin:0px;}
.customerWallet{
	.walletIcon{
		float:left;
		width: 12%;
		.walletFont{
			font-size:50px;
			color:#a437e9;
		}
	}
	.welletText{
			width: 93%;
		.heading{ font-size:23px;}
	}
	.amountTextColor{ color:#a437e9; } 
	
	.walletHistory{
	width: 70%;
    font-size: 14px;
		
		.walletAc{border-top: 1px solid #c6c6c6;
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.walletAp{
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.hlink{
		margin-left:10px;
		color:#a437e9;
		}
	}

}

</style>